.<template>
  <div class="agent_container">
    <div class="loan_contant">
      <div class="loan_box">
        <van-form @submit="onSubmit"
                  validate-trigger='onSubmit'
                  :validate-first="true">
          <van-cell-group class="group"
                          id="loan_group"
                          :border='false'>
            <van-field placeholder="请输入姓名"
                       label="姓名"
                       :maxlength='50'
                       name="nickName"
                       center
                       v-model.trim="loanUserInfor.nickName"
                       clearable
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
            <van-field v-if="loanUserInfor.phoneNumber"
                       center
                       placeholder="手机号"
                       label="手机号"
                       name="tel"
                       type="tel"
                       :value="loanUserInfor.phoneNumber"
                       readonly
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
            <van-field placeholder="请输入代理商姓名"
                       label="代理商姓名"
                       v-model.trim="list.agentUserName"
                       clearable
                       center
                       :maxlength='50'
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
            <van-field placeholder="请输入代理商手机号"
                       label="代理商手机号"
                       type="number"
                       center
                       v-model.trim="list.agentPhoneNumber"
                       clearable
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
          </van-cell-group>
          <van-button round
                      block
                      color="#EE0A25"
                      native-type="submit">提交申请</van-button>
        </van-form>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-dialog v-model="showDialog"
                @confirm="confirm"
                confirmButtonText='我知道了'>
      <div class="loan_dig">
        <van-icon name="passed"
                  v-if="returnStatus"
                  size="49"
                  color="rgba(25, 193, 92, 1)" />
        <van-icon name="warning-o"
                  v-if="!returnStatus"
                  size="49"
                  color="rgba(255, 145, 0, 1)" />
        <div class="loan_tip">{{tip}}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Calendar,
  Cell,
  Icon
} from "vant";
import { mapGetters } from "vuex";
import loading from "../../components/loading/loading";
import serviceApply from "../../api/apply/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Calendar.name]: Calendar,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
    loading
  },
  props: {},
  data () {
    return {
      // 弹窗层
      showDialog: false,
      // 弹出层显示图标
      returnStatus: false,
      // 弹出层提示
      tip: "",
      //加载中loading
      isLoading: false,
      list: {
        agentUserName: '',
        agentPhoneNumber: '',
      },
      // 拷贝数据
      loanUserInfor: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    // 自定义校验手机号
    // 提交
    onSubmit () {
      var phoneReg = /^(1[0-9])\d{9}$/;
      if (!phoneReg.test(this.list.agentPhoneNumber)) {
        Notify({ type: "danger", message: "代理商手机号格式错误" });
        return;
      }
      this.isLoading = true
      const postData = {
        mallUserName: this.loanUserInfor.nickName,
        phoneNumber: this.loanUserInfor.phoneNumber,
        agentUserName: this.list.agentUserName,
        agentPhoneNumber: this.list.agentPhoneNumber
      }
      serviceApply
        .agentToOwner(postData)
        .then((res) => {
          if (res.statusCode == 200) {
            this.isLoading = false
            if (res.data.status == true) {
              this.returnStatus = true
              this.showDialog = true
              this.tip = res.data.description
            } else {
              this.returnStatus = false
              this.showDialog = true
              this.tip = res.data.description
            }
          } else {
            Toast(res.errors);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹窗确认
    confirm () {
      this.$router.push({ name: "shopkeeper" });
    }
  },
  created () { },
  mounted () {
    // 深拷贝用户数据（用同一个数据会影响其他页面的同一个值）
    this.loanUserInfor = JSON.parse(JSON.stringify(this.userInfo))
  }
};
</script>
<style lang="less" scoped>
.agent_container {
  height: 100vh;
  overflow: hidden;
  #loan_group {
    margin-bottom: 24px;
  }
  .loan_contant {
    padding: 8px 16px 24px 16px;
  }
  .loan_box {
    height: 156px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
  }
  .van-cell {
    height: 52px;
  }
  .van-cell__value {
    line-height: 32px;
  }
  // ::v-deep .van-field__label--required:before {
  //   position: absolute;
  //   left: 6px;
  //   top: 13px;
  // }
  ::v-deep .van-field__label:before {
    content: '*';
    color: rgba(240, 7, 36, 1);
    position: absolute;
    left: 15px;
    top: 13px;
  }
  .van-field {
    padding-left: 25px;
  }
  .loan_dig {
    height: 124px;
    padding-top: 24px;
    text-align: center;
  }
  .loan_tip {
    margin-top: 20px;
    font-size: 14px;
    color: #000000;
  }
  // ::v-deep .van-field--error .van-field__control,
  // .van-field--error .van-field__control::placeholder {
  //   color: #fefefe;
  // }
}
</style>